export default "__VITE_PUBLIC_ASSET__6024cbe1__"